import { render, staticRenderFns } from "./SuccessSubmitForm22.vue?vue&type=template&id=03772813&scoped=true"
import script from "./SuccessSubmitForm22.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm22.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03772813",
  null
  
)

export default component.exports